export function isExternalLink(link) {
    return link?.startsWith('http') || link?.startsWith('tel:');
}
